import React from 'react';

import './ParagraphWithHeading.scss';

export default function ParagraphWithHeading(props) {
  return (
    <div className="paragraphTextWrapper">
      <h4 className="paragraphHeader">{props.heading}</h4>
      <p className="paragraphBody">{props.body}</p>
    </div>
  );
}
